import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IEdge, BMTableBuilding } from '@api/types'
import { BMTableBuildingFragment } from '@api/fragments'

interface Payload {
  data: {
    viewer: {
      company: {
        buildingsConnection: {
          edges: IEdge<BMTableBuilding>[]
        }
      }
    }
  }
}

const q = gql`
  query BuildingsSearch($where: BuildingWhereInput) {
    viewer {
      company {
        buildingsConnection(first: 7, where: $where) {
          edges {
            node {
              ...BMTableBuildingFragment
            }
          }
        }
      }
    }
  }
  ${BMTableBuildingFragment}
`

export default function search(query: string, includeOld: boolean): Promise<BMTableBuilding[]> {
  const variables = {
    where: {
      AND: [
        {
          OR: [{ name_contains: query }, { code_contains: query }, { address_contains: query }],
        },
        { includeOldBuildings: includeOld },
      ],
    },
  }

  return client.gql.query({ query: q, variables }).then(
    ({
      data: {
        viewer: {
          company: {
            buildingsConnection: { edges },
          },
        },
      },
    }: Payload) => edges.map(({ node }) => node)
  )
}
